import TenantDomain from "./tenant-domain";

export default class XeroDomain {
  tenantId: TenantDomain;

  constructor(tenantId: TenantDomain) {
    this.tenantId = tenantId;
  }
}
